import { useNavigate } from "react-router-dom";

const GoToSignup = (props = {}) => {
  const { loading } = props;
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/signup", { replace: true });
  };

  return (
    <p className="auth-switch-text">
      Don’t have an account?{" "}
      <button
        type="button"
        className="auth-switch-button"
        disabled={loading}
        onClick={handleClick}
      >
        Sign up
      </button>
    </p>
  );
};

export default GoToSignup;
